import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../components/ui/table";
import Pagination from "./Pagination";
import { useNavigate } from "react-router";


const apiUrl = process.env.REACT_APP_API_URL;

const formatDateTime = (dateString: string) => {
  const localDateString = dateString.replace(/Z$/, '');
  // local time formatte
  const date = new Date(localDateString); 

  const datePart = date.toLocaleDateString('en-AU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  return `${datePart}`;
};


export default function InspectionsHistoryTable() {
  const token = localStorage.getItem("token");
  const [inspectionsHistory, setInspectionsHistory] = useState<any[]>([]);
  const navigate = useNavigate();

  const [rowsPerPage, setRowsPerPage] = useState(15); // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(inspectionsHistory.length / rowsPerPage);

  const currentData = inspectionsHistory.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Calculate total pages and current data slice
  const totalEntries = inspectionsHistory.length;
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalEntries);

  const handlePageChange = (page: number) => {
    // setCurrentPage(page);
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const fetchInspectionsHistory = async () => {
    const response = await fetch(`${apiUrl}/inspection_history`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    });
    const result = await response.json();
    
    if (result.success) {
      setInspectionsHistory(result.inspectionHistory);
    } else {
      setInspectionsHistory([]);
    }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  };

  useEffect(() => {
    fetchInspectionsHistory();
  }, []);

  const handleRowClick = (inspectionHoistory: any) => {
   navigate("/update-inspection-history", { state: { inspectionHoistory } });
  }

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Inspection Date
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Inspection Type
                  </span>
                </div>
              </div>
            </TableCell>
						<TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Venue
                  </span>
                </div>
              </div>
            </TableCell>
						<TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Area
                  </span>
                </div>
              </div>
            </TableCell>
						<TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Status
                  </span>
                </div>
              </div>
            </TableCell>
						<TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Inspection Start Date
                  </span>
                </div>
              </div>
            </TableCell>
						<TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Inspection Due Date
                  </span>
                </div>
              </div>
            </TableCell><TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Sign Off Date
                  </span>
                </div>
              </div>
            </TableCell><TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Inspector
                  </span>
                </div>
              </div>
            </TableCell>
						<TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    KPI
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {currentData.map((inspectionHoistory) => (      
            <TableRow className="cursor-pointer hover:bg-[#ffffa3]" onClick={() => handleRowClick(inspectionHoistory)}  key={inspectionHoistory.compinspection_id}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
              <span>{formatDateTime(inspectionHoistory.inspdate)}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionHoistory.inspectionType}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionHoistory.venue}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
              <span>{inspectionHoistory.area}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionHoistory.status}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{formatDateTime(inspectionHoistory.inspstart)}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{formatDateTime(inspectionHoistory.actionsduedate)}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
              <span>{formatDateTime(inspectionHoistory.signoffdate)}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionHoistory.inspector}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionHoistory.kpi}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="border border-t-0 rounded-b-xl border-gray-100 py-2 pl-[18px] pr-4 dark:border-white/[0.05]">
        <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between">
          {/* Left side: Showing entries */}
          <div className="pb-3 xl:pb-0">
            <p className="pb-3 text-sm font-medium text-center text-gray-500 border-b border-gray-100 dark:border-gray-800 dark:text-gray-400 xl:border-b-0 xl:pb-0 xl:text-left">
              Showing {startIndex + 1} to {endIndex} of {totalEntries} entries
            </p>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
     </div>   
    </>
  );
}